import React from 'react';
import PropTypes from 'prop-types';

const CollapseButton = ({ onClick }) => {
  const getCollapseIcon = () => {
    return <i className="collapse__icon" />;
  };

  return (
    <button className="aside__button__collapse" onClick={onClick}>
      {getCollapseIcon()}
    </button>
  );
};

CollapseButton.propTypes = {
  onClick: PropTypes.func,
};

export default CollapseButton;
